import { styled } from '@mui/system';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const UploadImageScrollImagesDiv = styled('div')({
  width: '100px',
  height: '100px',
  display: 'block',
  borderRadius: '10px',
  backgroundColor: '#F9F9F9',
  marginBottom: '20px',
  position: 'relative',
  justifyContent: 'flex-start',
  cursor: 'pointer',
});

const UploadImageScrollImages = styled('object')({
  width: '100%',
  height: '100%',
  display: 'block',
  objectFit: 'cover',
  pointerEvents: 'none',
  border: '1px solid #EAEAEA',
  borderRadius: '10px',
  '> *': {
    display: 'flex',
  },
});

const DeleteIconButton = styled(IconButton)({
  backgroundColor: '#0277BD',
  color: 'white',
  height: '20px',
  width: '20px',
  position: 'absolute',
  top: '4px',
  right: '10px',
  '&:hover': {
    backgroundColor: '#0277BD',
  },
});

const CloseIconSized = styled(CloseIcon)({
  fontSize: '16px',
});

const UploadImageImagesDivLoading = styled('div')({
  width: '100px',
  height: '100px',
  display: 'flex',
  borderRadius: '10px',
  backgroundColor: '#F9F9F9',
  marginBottom: '20px',
  justifyContent: 'center',
  alignItems: 'center',
});

export {
  UploadImageScrollImagesDiv,
  UploadImageScrollImages,
  DeleteIconButton,
  CloseIconSized,
  UploadImageImagesDivLoading,
};
